// Claves evictables en orden de prioridad (más prescindibles primero).
// LOCAL_NEW_FORMS, LOCAL_UPDATED_FORMS, LOCAL_NEW_IMAGES, LOCAL_UPDATED_IMAGES
// y LOCAL_SESSION quedan excluidas — son datos críticos pendientes de sincronizar.
const EVICTABLE_CACHE_KEYS = [
  "cermaq_local_forms_options",
  "sso_areas_cache",
  "sso_form_params_cache",
  "sso_users_cache",
  "cermaq_local_all_inspections",
  "cermaq_local_my_inspections",
  "cermaq_local_help",
  "cermaq_local_forms_ad",
  "cermaq_local_forms_am",
  "cermaq_local_forms_p",
  "cermaq_local_forms_adm",
];

export const putLocal = (key, data) => {
  const serialized = JSON.stringify(data);
  const sizeInMB = (new Blob([serialized]).size / 1024 / 1024).toFixed(2);
  console.log(`[putLocal] Guardando ${key} - Tamaño: ${sizeInMB} MB`);

  const tryWrite = () => localStorage.setItem(key, serialized);

  try {
    tryWrite();
    console.log(`[putLocal] ✓ ${key} guardado exitosamente (${sizeInMB} MB)`);
    return true;
  } catch (error) {
    if (error.name !== "QuotaExceededError") {
      console.error(`[putLocal] ✗ ERROR guardando ${key}:`, error.message);
      return false;
    }

    console.warn(`[putLocal] ✗ QuotaExceededError para ${key} (${sizeInMB} MB). Liberando caché...`);

    // Guardar backup de las claves que vamos evictando por si el write falla
    const evicted = [];

    for (const evictKey of EVICTABLE_CACHE_KEYS) {
      if (evictKey === key) continue;
      const evictValue = localStorage.getItem(evictKey);
      if (evictValue === null) continue;

      evicted.push({ key: evictKey, value: evictValue });
      localStorage.removeItem(evictKey);
      console.warn(`[putLocal] Liberado: ${evictKey}`);

      try {
        tryWrite();
        console.log(`[putLocal] ✓ ${key} guardado tras liberar ${evictKey}`);
        return true;
      } catch (e) {
        // sigue liberando más
      }
    }

    // Si no se pudo guardar, restaurar lo evictado para no perder datos
    console.error(`[putLocal] ✗ No se pudo guardar ${key} incluso después de liberar todo el caché. Restaurando...`);
    for (const item of evicted) {
      try { localStorage.setItem(item.key, item.value); } catch (_) {}
    }
    return false;
  }
};

export const getLocal = (key, defaultValue) => {
  let data = localStorage.getItem(key);
  if (data) data = JSON.parse(data);
  else data = defaultValue;
  return data;
};

export const dropLocal = key => {
  localStorage.removeItem(key);
};

export const localSession = {
  setItem: (key, data) => {
    const stringify = JSON.stringify(data);
    const encrypted = btoa(stringify);
    localStorage.setItem(key, encrypted);
    return true;
  },
  getItem: key => {
    try {
      const encrypted = localStorage.getItem(key);
      if (encrypted) {
        const stringify = atob(encrypted);
        return JSON.parse(stringify);
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  },
};
